/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Feature } from './feature';


/**
 * Collection of geometric features
 */
import { ValidateUtils } from 'app/shared/utils';

export class FeatureCollection { 
    /**
     * GeoJSON type (FeatureCollection)
     */
    type: FeatureCollection.TypeEnum;
    /**
     * List of features
     */
    features: Array<Feature>;

    constructor(item?: Partial<FeatureCollection>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            type: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.type : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            features: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.features : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: FeatureCollection.isValid,
        };
    }

    static isValid(obj: FeatureCollection): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = FeatureCollection.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.type.isValid(item);
            result = result && validationObject.features.isValid(item);
            return result;
        } else {
            return false
        }
    }
}
export namespace FeatureCollection {
    export type TypeEnum = 'FeatureCollection';
    export const TypeEnum = {
        FeatureCollection: 'FeatureCollection' as TypeEnum
    };
}


